import React from 'react';
import { Container, Row, Col, Card, CardBody, CardTitle, Button } from 'reactstrap';
import { FaCheck } from 'react-icons/fa';
import userLogo from "../../../assets/img/icons/common/Group.png";
import userAddLogo from "../../../assets/img/icons/common/Group-add-2.png";
import userHelpLogo from "../../../assets/img/icons/common/need-support-icon.png";
import { useAPIContext } from '../../../utilities/Contexts/DCGAutomationPagesContextProvider';

const SelectRolePageContent = () => {
    const { navigateToPage } = useAPIContext();
    return (
        <Container style={{ marginTop: '20px' }}>
            <Row>
                <Col md="4">
                    <Card className="h-100 d-flex flex-column">
                        <CardBody className="text-center d-flex flex-column justify-content-between">
                            <div>
                                <i style={styles.icon}><img src={userLogo} alt="user logo" /></i>
                                <CardTitle tag="h4" className="mt-3">
                                    I’m the Portal Admin and need to create a new portal.
                                </CardTitle>
                                <p style={{ color: '#00AEA9' }}>The Portal Admin is responsible for:</p>
                                <ul className="list-unstyled">
                                    {[
                                        "Setting up & managing portal",
                                        "Adding & managing locations",
                                        "Adding & managing portal data",
                                        "Managing users & permissions",
                                    ].map((item, index) => (
                                        <li key={index} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
                                            <span style={{ minWidth: '18px', display: 'flex', justifyContent: 'center' }}>
                                                <FaCheck size={18} color="#00AEA9" />
                                            </span>
                                            <span style={{ marginLeft: '8px', textAlign: 'left' }}>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <Button color="primary" onClick={() => { navigateToPage('defaultRegion') }} className="btn-same-size mt-auto">I'M THE PORTAL ADMIN</Button>
                        </CardBody>
                    </Card>
                </Col>

                <Col md="4">
                    <Card className="h-100 d-flex flex-column">
                        <CardBody className="text-center d-flex flex-column justify-content-between">
                            <div>
                                <i style={styles.icon}><img src={userAddLogo} alt="user add logo" /></i>
                                <CardTitle tag="h4" className="mt-3">
                                    I purchased a device and need to join an existing portal.
                                </CardTitle>
                                <ul className="list-unstyled">
                                    <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
                                        <span style={{ minWidth: '18px', display: 'flex', justifyContent: 'center' }}>
                                            <FaCheck size={18} color="#00AEA9" />
                                        </span>
                                        <span style={{ marginLeft: '8px', textAlign: 'left' }}>
                                            I received a Join Code, so what do I do next?
                                        </span>
                                    </li>
                                </ul>
                                <Button color="primary" href="https://support.datecodegenie.com/app-overview/set-up-datecodegenie-app-on-new-integrated-device" target="_blank" className="btn-same-size mb-3">NEXT STEPS</Button>
                                <ul className="list-unstyled">
                                    <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
                                        <span style={{ minWidth: '18px', display: 'flex', justifyContent: 'center' }}>
                                            <FaCheck size={18} color="#00AEA9" />
                                        </span>
                                        <span style={{ marginLeft: '8px', textAlign: 'left' }}>
                                            I didn’t receive a Join Code, and I know my Portal Admin’s email address.
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <Button color="primary" onClick={() => navigateToPage('requestPortalJoinCode')} className="btn-same-size mt-auto">REQUEST INVITE CODE</Button>
                        </CardBody>
                    </Card>
                </Col>

                <Col md="4">
                    <Card className="h-100 d-flex flex-column">
                        <CardBody className="text-center d-flex flex-column justify-content-between">
                            <div>
                                <i style={styles.icon}><img src={userHelpLogo} alt="user help logo" /></i>
                                <CardTitle tag="h4" className="mt-3">
                                    I’m not sure where I fit!
                                </CardTitle>
                                <ul className="list-unstyled">
                                    {[
                                        "I need Customer Support.",
                                        "I don’t know my portal Admin’s email",
                                    ].map((item, index) => (
                                        <li key={index} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
                                            <span style={{ minWidth: '18px', display: 'flex', justifyContent: 'center' }}>
                                                <FaCheck size={18} color="#C8C8C8" />
                                            </span>
                                            <span style={{ marginLeft: '8px', textAlign: 'left' }}>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <Button color="primary" href="https://support.datecodegenie.com/en_US/set-up" target="_blank" className="btn-same-size mt-auto">GET HELP</Button>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

const styles = {
    icon: {
        textAlign: 'center',
        fontSize: '0.9em',
        paddingBottom: '5px'
    }
};

export default SelectRolePageContent;
